package com.gstechnovos.sanative.utils

import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

object Res {

    private const val BASE = "/images"

    object Strings {
        const val APP_NAME = "Sanative Rehab"
        const val EMAIL = "info@sanative.rehab"

        object Nav {
            const val HOME = "Home"
            const val SERVICES = "Services"
            const val TEAM = "Team"
            const val PATIENT_INFO = "Patient Info"
            const val FAQ = "FAQ"
            const val CONTACT = "Contact"
        }

        object Routes {
            const val HOME = "/"
            const val SERVICES = "/services"
            const val TEAM = "/team"
            const val PATIENT_INFO = "/patient-info"
            const val FAQ = "/faq"
            const val CONTACT = "/contact"
            const val BOOK = "/book"
            const val MAINTENANCE = "/maintenance"
            const val NOT_FOUND = "/404"
        }

        object Links {
            const val EMAIL = "mailto:${Strings.EMAIL}"
        }

        object Buttons {
            const val BOOK_APPOINTMENT = "Book Appointment"
            const val CONTACT_CLINIC = "Contact Clinic"
            const val LEARN_MORE = "Learn More"
            const val VIEW_SERVICES = "View Services"
            const val RETURN_HOME = "Return to Homepage"
            const val SUBMIT = "Submit"
            const val CANCEL = "Cancel"
        }

        object Errors {
            const val GENERIC = "Something went wrong. Please try again."
            const val NOT_FOUND = "The page you are looking for doesn't exist."
        }
    }

    object Images {

        const val ICON = "$BASE/icon.svg"
        object NotFound {
            private const val PATH = "$BASE/not_found"

            const val NOT_FOUND_IMG = "$PATH/not_found.svg"
        }

        object Maintenance {
            private const val PATH = "$BASE/maintenance"

            const val MAINTENANCE_COVER = "$PATH/maintenance.png"
            const val MAINTENANCE_IMG = "$PATH/physiotherapy.png"
            const val MAINTENANCE_GIF = "$PATH/maintenance-tips.gif"
        }

        object Home {
            private const val PATH = "$BASE/home"

            const val HERO = "$PATH/hero_rehab.jpg"
            const val ASSESSMENT = "$PATH/assessment.jpg"
            const val TREATMENT = "$PATH/treatment.jpg"
            const val RECOVERY = "$PATH/recovery.jpg"

            object Services {
                private const val SUB_PATH = "$PATH/services"

                const val REHAB = "$SUB_PATH/rehab.jpg"
                const val INJURY_ASSESSMENT = "$SUB_PATH/injury_assessment.jpg"
                const val MOBILITY = "$SUB_PATH/mobility.jpg"
                const val STRENGTH = "$SUB_PATH/strength.jpg"
                const val ONGOING_CARE = "$SUB_PATH/ongoing_care.jpg"
            }

            object Process {
                private const val SUB_PATH = "$PATH/process"

                const val INTAKE = "$SUB_PATH/intake.svg"
                const val ASSESSMENT = "$SUB_PATH/assessment.svg"
                const val PLAN = "$SUB_PATH/plan.svg"
                const val PROGRESS = "$SUB_PATH/progress.svg"
            }
        }

        object ServicesPage {
            private const val PATH = "$BASE/services"

            const val OVERVIEW = "$PATH/services_overview.jpg"

            object Categories {
                private const val SUB_PATH = "$PATH/categories"

                const val PHYSIOTHERAPY = "$SUB_PATH/physiotherapy.jpg"
                const val SPORTS_INJURY = "$SUB_PATH/sports_injury.jpg"
                const val MANUAL_THERAPY = "$SUB_PATH/manual_therapy.jpg"
                const val MOBILITY_TRAINING = "$SUB_PATH/mobility_training.jpg"
                const val STRENGTH_CONDITIONING = "$SUB_PATH/strength_conditioning.jpg"
            }
        }

        object TeamPage {
            private const val PATH = "$BASE/team"

            const val OVERVIEW = "$PATH/team_overview.jpg"
            const val PLACEHOLDER = "$PATH/practitioner_placeholder.jpg"
        }

        object PatientInfoPage {
            private const val PATH = "$BASE/patient-info"

            const val OVERVIEW = "$PATH/patient_info_overview.jpg"

            object Education {
                private const val SUB_PATH = "$PATH/education"

                const val FIRST_VISIT = "$SUB_PATH/first_visit.jpg"
                const val RECOVERY_PLAN = "$SUB_PATH/recovery_plan.jpg"
                const val HOME_EXERCISES = "$SUB_PATH/home_exercises.jpg"
            }
        }

        object ContactPage {
            private const val PATH = "$BASE/contact"

            const val CLINIC = "$PATH/clinic.jpg"
            const val MAP_PLACEHOLDER = "$PATH/map_placeholder.jpg"
        }

        object Common {
            private const val PATH = "$BASE/common"

            const val LOGO = "$PATH/logo.svg"
            const val LOGO_MARK = "$PATH/logo_mark.svg"
            const val BACK_TO_TOP = "$PATH/ic_back_to_top.svg"
        }
    }

    object Videos {
        private const val PATH = "/videos"

        object Home {
            const val HERO = "$PATH/home_hero.mp4"
        }

        object PatientInfoPage {
            const val EXERCISE_GUIDE = "$PATH/exercise_guide.mp4"
        }
    }

    object Icons {
        private const val PATH = "$BASE/icons"

        const val CALL = "$PATH/ic_call.svg"
        const val EMAIL = "$PATH/ic_email.svg"
        const val LOCATION = "$PATH/ic_location.svg"
        const val CHECKMARK = "$PATH/ic_checkmark.svg"
        const val ARROW_RIGHT = "$PATH/ic_arrow_right.svg"
        const val CALENDAR = "$PATH/ic_calendar.svg"
        const val CLOCK = "$PATH/ic_clock.svg"
        const val SHIELD = "$PATH/ic_shield.svg"
        const val HEART = "$PATH/ic_heart.svg"
        const val MOBILITY = "$PATH/ic_mobility.svg"
        const val STRENGTH = "$PATH/ic_strength.svg"

        object Social {
            private const val SUB_PATH = "$PATH/social"

            const val FACEBOOK = "$SUB_PATH/ic_facebook.svg"
            const val INSTAGRAM = "$SUB_PATH/ic_instagram.svg"
            const val LINKEDIN = "$SUB_PATH/ic_linkedin.svg"
        }
    }

    object Breakpoints {
        val SM = Breakpoint.SM
        val MD = Breakpoint.MD
        val LG = Breakpoint.LG
        val XL = Breakpoint.XL
        val XXL = Breakpoint.XXL
    }
}
